import Cookies from 'js-cookie';
const TokenKey = 'token';
const userInfo = "userInfo";
const userPerson = "person";
const auth = {
  getToken() {
    return Cookies.get(TokenKey);
  },
  setToken(token) {
    return Cookies.set(TokenKey, token);
  },
  setUserPerson(person) {
    return Cookies.set(userPerson, person);
  },
  removeToken() {
    return Cookies.remove(TokenKey);
  },
  loginOut(call) {
    Cookies.remove(TokenKey);
    Cookies.remove(userInfo);
    call();
  },
  getUserInfo() {
    return Cookies.get(userInfo);
  },
  setUserInfo(val) {
    return Cookies.set(userInfo, val);
    console.log(1)
  },
}

export default auth;



// WEBPACK FOOTER //
// ./src/utils/auth.js